<template>
    <div id="editor" v-if="currentUser">
        <b-container fluid>
            <router-view name="main" />
        </b-container>
    </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import MxSecurity from '@/mixins/security'

const nsEditor = namespace('editor')

@Component({
  components: {},
})

export default class extends Mixins(MxSecurity) {
  @nsEditor.Action('preload')
  private preload: any

  get hasAccess() {
    return this.canRead(9)
  }

  get versionText() {
    return process.env.VUE_APP_VERSION
  }
}
</script>

<style scoped>
#topology-editor {
  height: 80vw;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  line-height: 1.5;
  font-size: 20px;
}

.border-primary {
  border: 1px solid;
}

.border-secondary {
border: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.scrollable {
overflow: auto;
}
</style>

<style scoped lang="scss">
.editor-main {
height: 68vh;
}

.fullscreen-view {
position: absolute;
top: 0;
left: 0;
width: 100%;
.container-fluid {
  padding-left: 0;
  padding-right: 0;
  overflow: hidden;
}
.editor-main {
  height: 90vh;
}
}
</style>
<style lang="scss">
.scrollable-tree {
  overflow: auto;
  height: 60vh !important;
}

.scrollable-editor {
  overflow: auto;
  height: 60vh !important;
}
</style>
